import Store from "App/Store.js";
import dLogout from "Dispatchers/dLogout.js";

export default () => {
	const expiry = Store.getState().auth?.Expiration;
	if (expiry && (((expiry * 1000) - 900) < (new Date()).getTime())) {
		dLogout();
	}
};
